import { IconSettings2 } from "@tabler/icons-react"
import type {
  APStoreData,
  AutoPilotDef,
  HeroState,
  PreviewStat,
} from "../registry"
import { AktionenTab } from "./AktionenTab"
import { DatenbankTab } from "./DatenbankTab"

function heroText(state: HeroState): string {
  if (state.dbConfigured === null) return "Loading database…"
  if (!state.dbConfigured) {
    return "Database not yet configured — upload a document or describe your structure in chat."
  }
  const n = state.scopes.length
  return `${n} scope${n === 1 ? "" : "s"} active — upload a document to import more data.`
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getNotifications(_data: APStoreData): number {
  return 0
}

function getPreviewStats(data: APStoreData): PreviewStat[] {
  if (!data.dbConfigured) return []
  return [
    { label: "QMS/PREVIEW/SCOPES", value: data.scopes.length },
    { label: "QMS/PREVIEW/RECORDS", value: data.totalRecordCount },
  ]
}

export const ConfigurationAP: AutoPilotDef = {
  id: "configuration",
  name: "QMS/AP/CONFIGURATION/NAME",
  description: "QMS/AP/CONFIGURATION/DESCRIPTION",
  systemPrompt:
    "You are a database structure assistant for the quality management system. " +
    "You analyze uploaded documents and suggest an optimal structure for areas like suppliers, products, and customers. " +
    "Detected fields and relationships are presented clearly for confirmation. " +
    "Changes are only applied after explicit approval by the user.",
  icon: IconSettings2,
  apType: "configurator",
  scope: {
    primaryScopeId: null,
    visibleScopeIds: [], // empty = all scopes visible
  },
  chat: {
    systemPromptKey: "configuration",
    knownIntents: [
      "analysiere_dokument",
      "welche_daten_fehlen",
      "aktualisiere_daten",
    ],
  },
  unlockCondition: () => true,
  lockRequirements: [],
  getNotifications,
  getPreviewStats,
  hero: heroText,
  AktionenTab,
  DatenbankTab,
}
